import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';

export const StyledReferralCodeContent = styled.div`
  display: flex;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const StyledReferralCode = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    margin: ${LAYOUT.GUTTER / 2}px 0;
  }

  p:first-child {
    margin: 0 ${LAYOUT.GUTTER / 4}px 0 0;

    @media (max-width: 767px) {
      font-size: 14px;
    }
  }
`;

export const StyledBoxShadowText = styled.p`
  box-shadow: 0 0 20px 0 ${({ theme }) => theme.modals.border_color};
  padding: ${LAYOUT.GUTTER / 2}px;

  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const StyledAccountInfoContainer = styled.div`
  font-size: 16px;
`;

export const StyledReferralCodeInstructions = styled.p`
  margin: ${LAYOUT.GUTTER / 4}px 0 0 0;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 ${LAYOUT.GUTTER}px;

  @media (max-width: 767px) {
    margin: 0;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    display: none;
  }
`;

export const StyledCopiedText = styled.p`
  font-size: 12px;
  margin: 0 0 0 ${LAYOUT.GUTTER / 2}px;
`;
